import React, { useState, useEffect, ChangeEvent, forwardRef } from 'react';
import { InputGroup, FormControl } from 'react-bootstrap';
import { debounce } from 'debounce';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback1, IBindingAction } from '../../common/models/callback';
import { ReactComponent as Search } from '../../assets/icons/search.svg';
import styles from './styles.module.scss';
import Icon from '../Icon';

interface ISearchInputProps {
  width?: string;
  onChange: IBindingCallback1<string>;
  value: string;
  autoFocus?: boolean;
  intlId?: string;
  defaultPlaceholder?: string;
  onClear?: IBindingAction;
  variant?: 'primary' | 'secondary';
}

const SearchInput = forwardRef<HTMLInputElement, ISearchInputProps>(({
  onChange,
  width,
  value,
  autoFocus,
  defaultPlaceholder = 'Filter',
  intlId = 'searchInput.filter',
  variant = 'primary',
  onClear
}, ref) => {
  const [val, setValue] = useState(value);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setValue(event.currentTarget.value);
  const search = debounce((v: string) => onChange(v), 500);

  useEffect(() => {
    search(val);
    return () => search.clear();
  }, [val]);

  useEffect(() => {
    setValue(value);
  }, [value]);

  return (
    <InputGroup bsPrefix={styles[variant]}>
      <Search className={styles.searchIcon} />
      <FormattedMessage id={intlId} defaultMessage={defaultPlaceholder}>
        {placeholder => (
          <FormControl
            className="search-input"
            ref={ref}
            autoFocus={autoFocus}
            style={{ width }}
            placeholder={placeholder?.toString()}
            onChange={handleChange}
            bsPrefix={`${styles[variant]} ${styles.searchInput} ${onClear ? styles.inputWithBttn : ''}`}
            aria-describedby="basic-addon1"
            value={val}
          />
        )}
      </FormattedMessage>
      {onClear && val && (
        <button
          onClick={onClear}
          type="button"
        >
          <Icon icon="close" className={styles.clearBttn} />
        </button>
      )}
    </InputGroup>
  );
});

export default SearchInput;
